import React, { FunctionComponent } from 'react';
import { RemainingTicketsFormat } from '../../../constants/statsig';
import { getRemainingTicketsFormatExperimentValue } from '../../../utils/statsig';
import TicketRemainingTicketsCount, {
    TicketRemainingTicketsCountProps,
} from '../TicketRemainingTicketsCount';
import TicketRemainingUrgencySignal, {
    TicketRemainingUrgencySignalProps,
} from '../TicketRemainingTicketsCount/TicketRemainingUrgencySignal';

export interface TicketRemainingTicketsSwitcherProps
    extends TicketRemainingTicketsCountProps {
    urgencySignals: TicketRemainingUrgencySignalProps['urgencySignals'];
}

const TicketRemainingTicketsSwitcher: FunctionComponent<
    TicketRemainingTicketsSwitcherProps
> = ({
    isSoldOut,
    numTicketsRemaining,
    className,
    urgencySignals,
}: TicketRemainingTicketsSwitcherProps) => {
    return getRemainingTicketsFormatExperimentValue() ===
        RemainingTicketsFormat.showUrgencySignals ? (
        <TicketRemainingUrgencySignal
            urgencySignals={urgencySignals}
            isSoldOut={isSoldOut}
            numTicketsRemaining={numTicketsRemaining}
            className={className}
            data-testid="ticket-remaining-urgency-signal"
        />
    ) : (
        <TicketRemainingTicketsCount
            isSoldOut={isSoldOut}
            numTicketsRemaining={numTicketsRemaining}
            className={className}
        />
    );
};

export default TicketRemainingTicketsSwitcher;
